import { makeCompanyQueryHttp } from '../../_shared/infrastructure/company-query.http';
import type { InstitutionalsGateway } from './institutionals.gateway';

/** Client Institutionals list → `GET /companies` (licence-scoped server-side). */
export const httpInstitutionalsGateway: InstitutionalsGateway = makeCompanyQueryHttp('/companies');
